import React from 'react';
import { QuestionRendererProps } from './types';
import { getQuestionTypeConfig } from '../../../config/questionTypeRegistry';
import { QuestionErrorBoundary } from '../QuestionErrorBoundary';
import { warn } from '../../../utils/logger';
export function QuestionRendererFactory(props: QuestionRendererProps) {
  const {
    question
  } = props;
  const config = getQuestionTypeConfig(question.questionType || 'multiple_choice');
  const Renderer = config.Renderer;
  // Wrap renderer in error boundary to prevent crashes
  return <QuestionErrorBoundary questionId={question.id} onReset={() => {
    // Reset handler: Force re-render by clearing any cached state
    // The parent PracticeSession will handle moving to next question
    warn(`Question ${question.id} renderer crashed and was reset`);
  }} data-id="element-4617">
      <Renderer {...props} data-id="element-4618" />
    </QuestionErrorBoundary>;
}